import React from 'react';

import { TestCyclesOverviewTableGadget } from '@qality/common-components/src/organisms//TestCyclesOverviewTableGadget';
import { TestCycle } from '@qality/common-model';

export interface RecentTestCyclesTableProps {
  testCycles: TestCycle[];
  isProjectContext: boolean;
  handleOverviewAction: (testCycleId) => void;
}

export const RecentTestCyclesTableView: React.FC<RecentTestCyclesTableProps> =
  ({
    testCycles,
    isProjectContext,
    handleOverviewAction,
  }: RecentTestCyclesTableProps) => {
    return (
      <TestCyclesOverviewTableGadget
        testCycles={testCycles}
        showStatus={false}
        showProject={!isProjectContext}
        handleOverviewAction={handleOverviewAction}
      />
    );
  };
